export default __webpack_public_path__ + "static/media/projects.05b69feb.png";